import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  MatSlideToggle,
  MatSlideToggleChange,
} from '@angular/material/slide-toggle';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { CustomSnackbarService } from '../../components/custom-snackbar/custom-snackbar-service';
import { confirmationBottomSheet } from '../../..//data/utils/bottom-sheet-confirmation.utils';
import { UsersService } from '../../../data/services/user.service';
import { Show } from 'src/app/modules/shows/models';

@Component({
  selector: 'app-show-card',
  templateUrl: './show-card.component.html',
  styleUrls: ['./show-card.component.scss'],
})
export class ShowCardComponent implements OnInit {
  @Input() showInfo?: Show;
  @Input() active: string = '';

  @Output() deleteEvent: EventEmitter<Show> = new EventEmitter<Show>();
  @Output() editEvent: EventEmitter<Show> = new EventEmitter<Show>();
  @Output() reportEvent: EventEmitter<Show> = new EventEmitter<Show>();
  
  statusToggle: boolean = false;
  matToggle?: MatSlideToggle;

  constructor(
    private readonly bottomSheet: MatBottomSheet,
    private readonly snackbar: CustomSnackbarService,
    private readonly userService: UsersService
  ) {
  }

  ngOnInit(): void {
    let result = this.isChecked();
    if (result) {
      this.active = 'Ativo';
    } else {
      this.active = 'Desativado';
    }
  }

  compareDate(){
    const actualDateTime = new Date().getTime()
    if(this.showInfo){
      const endDateTime = new Date(this.showInfo.endDate).getTime()
      if(endDateTime < actualDateTime){
        return false
      }
      return true
    }
    return false
  }

  isChecked() {
    if (!this.showInfo?.active) {
      return (this.statusToggle = false);
    }
    return (this.statusToggle = true);
  }

  onClick(event: any): void {
    event.stopPropagation();
  }

  callOpenDeleteDialog(show: Show){
    this.deleteEvent.emit(show)  
  }

  callOpenEditDialog(show: Show){
    this.editEvent.emit(show)
  }

  openReportDialog(show: Show){
    this.reportEvent.emit(show)
  }
}
